export default __webpack_public_path__ + "static/media/backward.d43ef212.svg";